import React from 'react'
import { Paragraph, QuickGlanceOverlay } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { Link } from '@fs/zion-router'
import usePrisonAccess from '../../../../../Give/hooks/usePrisonAccess'

const RecordTooltip = ({ overlay }) => {
  const [t] = useTranslation()
  const { accessFromPrison, isReady } = usePrisonAccess()

  return (
    <QuickGlanceOverlay {...overlay} title={t('family-review.record-tool-tip.title', 'What is a record?')}>
      <Paragraph>
        {t(
          'family-review.record-tool-tip.description',
          'A record is a document that certifies a life event. It can be as large as a few images or as small as a line or two on a ledger or register.'
        )}
      </Paragraph>
      {!accessFromPrison && isReady && (
        <Paragraph>
          <Link
            to="https://www.familysearch.org/en/help/helpcenter/article/what-is-the-difference-between-a-record-and-an-image"
            target="__blank"
          >
            {t('family-review.record-tool-tip.link-text', 'Learn More')}
          </Link>
        </Paragraph>
      )}
    </QuickGlanceOverlay>
  )
}

export default RecordTooltip
